import React, { useState, useCallback, useEffect } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import debounce from 'lodash/debounce';

const ValueFilterCell = ({ value, onChange }) => {
  const [filterValue, setFilterValue] = useState(value);

  const debouncedOnChange = useCallback(
    debounce(async (event) => {
      onChange(event);
    }, 700),
    [],
  );

  const handleChange = (event) => {
    setFilterValue(event.value);
    debouncedOnChange(event);
  };

  useEffect(() => {
    setFilterValue(value ?? '');
  }, [value]);

  return <Input onChange={handleChange} value={filterValue} style={{ width: '95%' }} />;
};

export default ValueFilterCell;
